import * as T from '@effect-ts/core/Effect'
import type { AxiosError } from 'axios'
import axios from 'axios'

import { Contact } from '../../_models/Contact'
import { Evaluation } from '../../_models/Evaluation'
import { GetType } from './axios'

export default axios.create({
  baseURL: '/api/',
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
})

export const GET_Contact = (id: number): T.IO<string | Error | AxiosError, Contact> =>
  GetType(Contact)(`/api/v1/contacts/${id}`)

export const GET_Evaluation = (id: number): T.IO<string | Error | AxiosError, Evaluation> =>
  GetType(Evaluation)(`/api/v1/evaluations/${id}`)
